// Open faq on click
jQuery(document).ready(function ($) {
    $('.tab-section .single-tab').on('click', function() {
        $(this).children().last().slideToggle();
        $(this).toggleClass('active');
    });
});